/**
 * Hover-Intent für das Header-Megamenü (und Dropdown-Menü).
 * Öffnet die <header-menu>-Elemente sanft nach kurzem Hover statt sofort beim
 * ersten Überfahren (verhindert Flackern), und schließt sie erst nach einer
 * kurzen Verzögerung beim Verlassen (damit der Weg zur Dropdown-Fläche nicht
 * versehentlich schließt).
 *
 * WICHTIG: Dawn registriert das Tag <header-menu> bereits nativ als eigenes
 * Custom Element (class HeaderMenu extends DetailsDisclosure, siehe global.js),
 * das Klick-, Escape- und Fokus-Verhalten regelt. Dieses Skript definiert daher
 * KEIN neues Custom Element, sondern hängt nur zusätzliche mouseenter/mouseleave-
 * Listener an die bereits vorhandenen Elemente an. Das setzt/entfernt lediglich
 * das native "open"-Attribut des <details>-Elements, wodurch ganz normal auch
 * das eingebaute "toggle"-Event (und damit Dawns eigene onToggle-Logik) feuert.
 * Klick- und Tastatur-Bedienung bleiben dadurch vollständig unverändert erhalten.
 */
(function () {
  var OPEN_DELAY = 100;
  var CLOSE_DELAY = 300;

  function isCoarsePointer() {
    return window.matchMedia('(pointer: coarse)').matches;
  }

  function setupHoverIntent(headerMenuEl) {
    if (headerMenuEl.hasAttribute('data-hover-intent-bound')) return;
    headerMenuEl.setAttribute('data-hover-intent-bound', 'true');

    var details = headerMenuEl.querySelector(':scope > details');
    if (!details) return;

    var openTimer = null;
    var closeTimer = null;

    function clearTimers() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    }

    headerMenuEl.addEventListener('mouseenter', function () {
      if (isCoarsePointer()) return;
      clearTimers();
      openTimer = window.setTimeout(function () {
        document.querySelectorAll('header-menu > details[open]').forEach(function (openDetails) {
          if (openDetails !== details) {
            openDetails.open = false;
          }
        });
        details.open = true;
      }, OPEN_DELAY);
    });

    headerMenuEl.addEventListener('mouseleave', function () {
      if (isCoarsePointer()) return;
      clearTimers();
      closeTimer = window.setTimeout(function () {
        details.open = false;
      }, CLOSE_DELAY);
    });
  }

  /**
   * Direkt-Navigation fuer die Hauptmenuepunkte "Damen"/"Bodywear"/"Herren"
   * (Fix 2026-09-18 (2), PageSpeed-Desktop-Audit "Beruehrungszielbereiche").
   * Bisher lag dafuer ein <a> verschachtelt IM <summary> - zwei ueberlappende
   * Klickziele, von Lighthouse (target-size) bemaengelt und technisch invalides
   * HTML (interaktiv-in-interaktiv). Jetzt traegt das <summary> nur noch ein
   * data-href-Attribut (siehe snippets/header-mega-menu.liquid); die Navigation
   * passiert hier per JS:
   *   - Maus/Trackpad (Hover verfuegbar, feiner Zeiger): echter Mausklick auf den
   *     Menuepunkt navigiert zur Kollektion (das Menue ist per Hover-Intent ohnehin
   *     schon offen). Strg/Cmd/Shift+Klick und Mittelklick oeffnen wie bei einem
   *     normalen Link einen neuen Tab.
   *   - Touch (pointer: coarse) und Tastatur (Enter/Leertaste erzeugen ein
   *     click-Event mit detail === 0): KEINE Navigation, nur das normale
   *     Auf-/Zuklappen des Menues - wie bei SALE/Stories/Filialen.
   */
  function isHoverPointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function findTopLinkSummary(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('summary[data-href]');
  }

  function setupTopLinkNavigation() {
    document.addEventListener('click', function (event) {
      var summary = findTopLinkSummary(event.target);
      if (!summary) return;
      if (!isHoverPointer() || isCoarsePointer()) return;
      if (event.detail === 0) return; // Tastatur (Enter/Leertaste) -> nur auf-/zuklappen
      var href = summary.getAttribute('data-href');
      if (!href) return;
      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        window.open(href, '_blank', 'noopener');
        return;
      }
      window.location.href = href;
    });

    document.addEventListener('auxclick', function (event) {
      if (event.button !== 1) return;
      var summary = findTopLinkSummary(event.target);
      if (!summary || !isHoverPointer()) return;
      var href = summary.getAttribute('data-href');
      if (!href) return;
      event.preventDefault();
      window.open(href, '_blank', 'noopener');
    });
  }

  /**
   * Lazy-Load für eingebettete iframes im Megamenü (z. B. die Google-Maps-Karten
   * bei "Filialen", siehe assets/component-mega-menu.css / snippets/header-mega-menu.liquid
   * für Desktop UND snippets/header-drawer.liquid für die mobile Menü-Schublade).
   * Grund (Performance-Fix, 2026-09-06): Das Desktop-Panel ".mega-menu__content" bleibt aus
   * Animationsgründen technisch immer "display:block" (nur opacity/visibility gesteuert),
   * auch wenn das <details>-Element geschlossen ist. Ein iframe mit gesetztem "src" hätte
   * dadurch auf JEDER Seite sofort geladen, unabhängig davon, ob der Menüpunkt je geöffnet
   * wird. Betroffene iframes tragen daher im Theme nur "data-src" statt "src"; hier wird
   * "src" erst beim tatsächlichen Öffnen des jeweiligen Menüpunkts nachgetragen (einmalig).
   *
   * WICHTIG: Der Listener reagiert bewusst auf JEDES <details>-Toggle-Event (nicht nur
   * "details.mega-menu"), da die mobile Menü-Schublade (header-drawer.liquid) für "Filialen"
   * ein eigenes <details id="Details-menu-drawer-menu-item-N"> ohne die Klasse "mega-menu"
   * verwendet. Für <details> ohne passende iframes ist der querySelectorAll-Aufruf einfach
   * ein No-op, daher ist die breitere Erkennung unbedenklich. "toggle" ist das native
   * <details>-Event und feuert unabhängig davon, ob "open" per Hover-Intent oben, per
   * Klick/Touch oder per Tastatur gesetzt wurde.
   */
  function lazyLoadMegaMenuIframes(details) {
    if (!details.open) return;
    details.querySelectorAll('.mega-menu__map iframe[data-src]').forEach(function (iframe) {
      // Wichtig (mobile Menü-Schublade): "Filialen" steckt als eigenes, zunächst
      // geschlossenes <details> INNERHALB des äußeren Schubladen-<details>. Öffnet
      // jemand nur die Schublade (Hamburger-Icon), feuert dafür ebenfalls ein
      // "toggle"-Event, dessen Ziel aber das äußere <details> ist. Ohne diesen Check
      // würde die Karte bereits beim Öffnen der Schublade laden, nicht erst beim
      // tatsächlichen Aufklappen von "Filialen". iframe.closest('details') liefert
      // das NÄCHSTGELEGENE <details> – stimmt es nicht mit dem soeben umgeschalteten
      // überein, gehört das iframe zu einem noch geschlossenen, verschachtelten
      // <details> und wird (noch) übersprungen.
      if (iframe.closest('details') !== details) return;
      iframe.src = iframe.getAttribute('data-src');
      iframe.removeAttribute('data-src');
    });
  }

  /**
   * Einheitliche Tiefe aller Desktop-Megamenue-Karten (2026-09-28, auf Wunsch Marina):
   * Alle Reiter (Damenmode, Bodywear, Herrenmode, SALE, Stories, Filialen) klappen gleich
   * tief auf. Die Hoehe der Karten haengt vom Inhalt und von der Fensterbreite ab (Bilder
   * und Karten sind quadratisch, skalieren mit der Spaltenbreite) - daher per JS statt fester
   * CSS-Hoehe: Beim Laden, nach "load"/Schriften und bei Groessenaenderung wird die natuerliche
   * Hoehe jeder Karte gemessen und die groesste als min-height auf alle gesetzt.
   * Ab 1200px ist das die Hoehe von Damenmode (bei 1440px: 324px); darunter kann "Filialen"
   * (Adresstexte) hoeher sein und gibt dann das Mass vor (bei 990px: 367px).
   * Messen: Geschlossene <details> rendern ihren Inhalt nicht, daher wird "open" fuer die
   * Messung synchron gesetzt und sofort wieder entfernt - ohne Zwischen-Paint, also unsichtbar.
   * Das dabei ausgeloeste "toggle"-Event sieht details.open === false, die Google-Maps-iframes
   * (Lazy-Load oben) laden dadurch NICHT vorzeitig (geprueft). Unter 990px (mobile Schublade)
   * wird nichts gesetzt.
   */
  function equalizeMegaMenuHeights() {
    var panels = document.querySelectorAll('.header__inline-menu details.mega-menu > .mega-menu__content');
    if (!panels.length) return;
    panels.forEach(function (panel) {
      panel.style.minHeight = '';
    });
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var max = 0;
    panels.forEach(function (panel) {
      var details = panel.parentElement;
      var wasOpen = details.hasAttribute('open');
      if (!wasOpen) details.setAttribute('open', '');
      var height = panel.offsetHeight;
      if (!wasOpen) details.removeAttribute('open');
      if (height > max) max = height;
    });
    if (!max) return;
    panels.forEach(function (panel) {
      panel.style.minHeight = max + 'px';
    });
  }

  function setupEqualMegaMenuHeights() {
    equalizeMegaMenuHeights();
    window.addEventListener('load', equalizeMegaMenuHeights);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeMegaMenuHeights);
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(equalizeMegaMenuHeights, 150);
    });
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(setupHoverIntent);
    setupTopLinkNavigation();
    setupEqualMegaMenuHeights();
    // "toggle" bubbelt nicht, daher im Capturing-Modus auf document lauschen.
    document.addEventListener(
      'toggle',
      function (event) {
        if (event.target && event.target.tagName === 'DETAILS') {
          lazyLoadMegaMenuIframes(event.target);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
